module.exports = {
    yes: 'Yes',
    no: 'No',
};
